import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message, Typography, Tabs, Alert } from 'antd';
import { UserOutlined, LockOutlined, PhoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { adminLogin, parentLogin } from '../api/auth';
import PhoneInput from '../components/common/PhoneInput';
import useAuthStore from '../store/authStore';
import useSettingsStore from '../store/settingsStore';
import { apiErrorMessage } from '../utils/apiError';

const { Title } = Typography;
const { TabPane } = Tabs;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const { appName, fetchSettings } = useSettingsStore();
  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const handleLogin = async (values, isParent = false) => {
    setLoading(true);
    try {
      const response = isParent
        ? await parentLogin(values.phone, values.password)
        : await adminLogin(values.email, values.password);

      const { user, first_login } = response.data;
      login(user);

      if (first_login) {
        navigate('/change-password');
      } else if (user.role === 'parent') {
        navigate('/parent/dashboard');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      message.error(apiErrorMessage(error, 'Giriş başarısız.'));
    } finally {
      setLoading(false);
    }
  };

  const LoginForm = ({ isParent = false }) => (
    <Form
      name={isParent ? 'parent-login' : 'admin-login'}
      onFinish={(values) => handleLogin(values, isParent)}
      layout="vertical"
      size="large"
    >
      {/* Veliler telefonla, personel e-posta ile giriyor. */}
      {isParent ? (
        <Form.Item
          name="phone"
          rules={[
            { required: true, message: 'Telefon numaranızı giriniz.' },
            // 10 hane kuralı KALDIRILDI: yurt dışı numaralar farklı uzunlukta
            // ve bu kural o velilerin giriş ekranını geçmesini engelliyordu.
            // Değer artık "+" ve ülke kodu içeriyor (bkz. PhoneInput).
            {
              pattern: /^\+\d{8,15}$/,
              message: 'Telefon numarasını ülke kodunu seçerek giriniz (örn. 5321234567).',
            },
          ]}
        >
          <PhoneInput prefix={<PhoneOutlined />} placeholder="Telefon (5321234567)" />
        </Form.Item>
      ) : (
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'E-posta giriniz.' },
            { type: 'email', message: 'Geçerli bir e-posta giriniz.' },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="E-posta" />
        </Form.Item>
      )}

      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Şifre giriniz.' }]}
      >
        <Input.Password prefix={<LockOutlined />} placeholder="Şifre" />
      </Form.Item>

      <Form.Item style={{ marginBottom: isParent ? 8 : undefined }}>
        <Button type="primary" htmlType="submit" loading={loading} className="w-full">
          Giriş Yap
        </Button>
      </Form.Item>

      {/* Yalnızca veli sekmesinde. Portal tüm velilere açıldı ve hesapların
          hiçbirinde önceden belirlenmiş şifre YOK — veli kendi şifresini
          buradan kuruyor.

          Metin bağlantı DEĞİL, kutu: afişteki karekod bu sayfaya düşüyor ve
          gelen velinin çoğu ilk kez giriyor. Formu görüp "benim şifrem yok"
          diye takılırsa kuruma telefon açıyor; bu kutu tam da o anda
          görünmek zorunda. */}
      {isParent && (
        <Alert
          type="info"
          message="İlk kez mi giriyorsunuz?"
          description="Şifreniz yok. Telefon numaranız ve çocuğunuzun T.C. kimlik numarasıyla kendi şifrenizi belirleyin."
          action={
            <Button size="small" type="primary" onClick={() => navigate('/uyelik-aktiflestir')}>
              Üyeliğimi Aktifleştir
            </Button>
          }
          style={{ marginTop: 8 }}
        />
      )}
    </Form>
  );

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <Card className="w-full max-w-md shadow-lg">
        <div className="text-center mb-6">
          <Title level={2}>{appName}</Title>
        </div>

        {/* VELİ SEKMESİ VARSAYILAN — 515 veliye karşı ~10 personel.
            Personel her gün giriyor ve bir tık fazladan tıklamayı öğrenir;
            veli ayda bir giriyor ve arayüze en az aşina olan taraf o.
            Ayrıca aktifleştirme sayfasından "giriş yapmak istiyorum" ile
            dönen kişi doğrudan doğru sekmeye düşüyor. */}
        <Tabs defaultActiveKey="parent" centered>
          <TabPane tab="Veli Girişi" key="parent">
            <LoginForm isParent={true} />
          </TabPane>
          <TabPane tab="Personel Girişi" key="staff">
            <LoginForm isParent={false} />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default Login;